import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  container: {
    display: 'grid',
    gap: theme.spacing(4),
    justifyItems: 'center',
  },
  descriptionCounter: {
    justifySelf: 'end',
  },
}));
